/**
 * RagsObject model
 */

import { Action, SetupActionData } from './Action';
import { CustomProperty, SetupCustomPropertyData } from './CustomProperty';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];
declare var TheGame: any;

export class RagsObject {
    locationtype: string = "LT_NULL";
    UniqueIdentifier: string = "";
    locationname: string = "";
    GroupName: string = "";
    name: string = "";
    description: string = "";
    sdesc: string = "";
    preposition: string = "a";
    Actions: Action[] = [];
    LayeredZoneLevels: string = "";
    CustomProperties: CustomProperty[] = [];
    bCarryable: boolean = false;
    bWearable: boolean = false;
    bOpenable: boolean = false;
    bLockable: boolean = false;
    bEnterable: boolean = false;
    bReadable: boolean = false;
    bContainer: boolean = false;
    dWeight: number = 0.0;
    bWorn: boolean = false;
    bRead: boolean = false;
    bLocked: boolean = false;
    bOpen: boolean = false;
    bEntered: boolean = false;
    bVisible: boolean = true;
    bEnterFirstTime: boolean = false;
    bLeaveFirstTime: boolean = false;
    bImportant: boolean = false;
    ActionsUseAdvanced: boolean = false;

    cloneForDiff(): {
        locationtype: string;
        locationname: string;
        name: string;
        description: string;
        sdesc: string;
        preposition: string;
        Actions: any[];
        CustomProperties: any[];
        bCarryable: boolean;
        bWearable: boolean;
        bOpenable: boolean;
        bLockable: boolean;
        bEnterable: boolean;
        bReadable: boolean;
        bContainer: boolean;
        dWeight: number;
        bWorn: boolean;
        bLocked: boolean;
        bOpen: boolean;
        bVisible: boolean;
        bEnterFirstTime: boolean;
        bLeaveFirstTime: boolean;
        bImportant: boolean;
    } {
        return {
            locationtype: this.locationtype,
            locationname: this.locationname,
            name: this.name,
            description: this.description,
            sdesc: this.sdesc,
            preposition: this.preposition,
            Actions: (window as any).ArrayCloneForDiff?.(this.Actions) || this.Actions.slice(),
            CustomProperties: (window as any).ArrayCloneForDiff?.(this.CustomProperties) || this.CustomProperties.slice(),
            bCarryable: this.bCarryable,
            bWearable: this.bWearable,
            bOpenable: this.bOpenable,
            bLockable: this.bLockable,
            bEnterable: this.bEnterable,
            bReadable: this.bReadable,
            bContainer: this.bContainer,
            dWeight: this.dWeight,
            bWorn: this.bWorn,
            bLocked: this.bLocked,
            bOpen: this.bOpen,
            bVisible: this.bVisible,
            bEnterFirstTime: this.bEnterFirstTime,
            bLeaveFirstTime: this.bLeaveFirstTime,
            bImportant: this.bImportant,
        };
    }
}

export function SetupObjectData(GameData: any[]): RagsObject {
    const TheObject = new RagsObject();
    TheObject.name = GameData[0];
    TheObject.UniqueIdentifier = GameData[1];
    TheObject.locationtype = GameData[2];
    TheObject.locationname = GameData[3];
    TheObject.description = GameData[4];
    TheObject.sdesc = GameData[5];
    TheObject.preposition = GameData[6];
    TheObject.bCarryable = GameData[7];
    TheObject.bWearable = GameData[8];
    TheObject.bOpenable = GameData[9];
    TheObject.bLockable = GameData[10];
    TheObject.bEnterable = GameData[11];
    TheObject.bReadable = GameData[12];
    TheObject.bContainer = GameData[13];
    TheObject.dWeight = GameData[14];
    TheObject.bWorn = GameData[15];
    TheObject.bRead = GameData[16];
    TheObject.bLocked = GameData[17];
    TheObject.bOpen = GameData[18];
    TheObject.bVisible = GameData[19];
    TheObject.LayeredZoneLevels = GameData[20];
    for (let i = 0; i < GameData[21].length; i++) {
        TheObject.CustomProperties.push(SetupCustomPropertyData(GameData[21][i]));
    }
    for (let j = 0; j < GameData[22].length; j++) {
        TheObject.Actions.push(SetupActionData(GameData[22][j]));
    }
    TheObject.ActionsUseAdvanced = Boolean(GameData[23]);
    return TheObject;
}

/** Simpler function than objecttostring() */
export function objectToString(curobject: RagsObject, withPreposition?: boolean): string {
    if (withPreposition === undefined) withPreposition = false;

    // Same as GameObject.GetDisplayName() (and GetDisplayStringNameOnly())
    // In RAGS, the preposition is only shown in:
    //  * The message that lists all the objects and characters in the room ("You can see...")
    //  * The message that lists all the objects wore/carried by a character ("X is wearing/carrying:...")
    //  * In messages from CT_ITEM_LAYERED_REMOVE/CT_ITEM_LAYERED_WEAR
    let result = '';
    if (withPreposition && curobject.preposition.length > 0) {
        result += curobject.preposition + ' ';
    }

    if (curobject.sdesc.trim().length > 0) {
        result += curobject.sdesc;
    } else {
        result += curobject.name;
    }

    return result;
}

/**
 * Convert object to string representation
 */
export function objecttostring(curobject: RagsObject): string {
    let retval = "";
    if (curobject.locationtype == "LT_IN_OBJECT" || curobject.locationtype == "LT_CHARACTER")
        retval += "  ";
    if (curobject.sdesc.trim().length > 0) {
        if (TheGame != null)
            retval += (window as any).PerformTextReplacements?.(curobject.sdesc, null) || curobject.sdesc;
        else
            retval += curobject.name;
    } else {
        retval += curobject.name;
    }
    if (curobject.bOpenable && !curobject.bOpen)
        retval += " (closed)";
    if ((curobject.bOpenable) && (curobject.bOpen))
        retval += " (open)";
    if (curobject.bWorn)
        retval += " (worn)";
    return retval;
}
